const BANCO_DAUNIA_CONTACTS = {
  organization: 'Banco Alimentare della Daunia',
  legalName: 'Francesco Vassalli ODV',
  tagline: 'Condividere il valore del cibo',
  address: 'Via Manfredonia km. 2.2, 71121 Foggia (FG)',
  phone: '0881 776484',
  phoneHref: 'tel:+390881776484',
  email: 'info@daunia.bancoalimentare.it',
  website: 'https://www.bancoalimentare.it/sedi-locali/daunia-foggia',
  donateUrl: 'https://www.bancoalimentare.it/dona-ora',
  social: [
    {
      id: 'facebook',
      label: 'Facebook — Banco Alimentare della Daunia',
      href: 'https://www.facebook.com/bancodaunia',
    },
    {
      id: 'instagram',
      label: 'Instagram — @bancodaunia',
      href: 'https://www.instagram.com/bancodaunia/',
    },
    {
      id: 'youtube',
      label: 'YouTube — Banco Alimentare',
      href: 'https://www.youtube.com/user/BancoAlimentare',
    },
    {
      id: 'linkedin',
      label: 'LinkedIn — Banco Alimentare',
      href: 'https://www.linkedin.com/company/banco-alimentare/',
    },
  ],
};

export { BANCO_DAUNIA_CONTACTS };
